module.exports = __webpack_public_path__ + "img/171.71c66333.jpg";